import { Map } from 'immutable';
import { createSelector } from 'reselect';

const selectOpenIdObject = (state) => state.getIn(['me', 'openId', 'openId'], Map());

const makeSelectOpenIdNetwork = () =>
  createSelector(selectOpenIdObject, (state) => state.getIn(['network']));

const makeSelectOpenId = () =>
  createSelector(selectOpenIdObject, (state) => state.getIn(['data'], false));

const selectSignupOpenId = (state) => state.getIn(['me', 'openId', 'signup'], Map());

const makeSelectSignupOpenIdNetwork = () =>
  createSelector(selectSignupOpenId, (state) => state.getIn(['network']));
const selectLoginOpenId = (state) => state.getIn(['me', 'openId', 'login'], Map());

const makeSelectLoginOpenIdNetwork = () =>
  createSelector(selectLoginOpenId, (state) => state.getIn(['network']));

export {
  makeSelectLoginOpenIdNetwork,
  makeSelectOpenId,
  makeSelectOpenIdNetwork,
  makeSelectSignupOpenIdNetwork,
};
